import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[staffLocationsTooltip]',
  standalone: true,
})
export class StaffLocationsTooltipDirective implements OnDestroy {
  @Input('staffLocationsTooltip') text = '';

  private tooltipEl: HTMLElement | null = null;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const host = this.elementRef.nativeElement;
    const value = this.text.trim();

    if (!value || value === '-' || host.scrollWidth <= host.clientWidth) {
      return;
    }

    this.removeTooltip();

    const rect = host.getBoundingClientRect();
    const tooltip = document.createElement('div');

    Object.assign(tooltip.style, {
      position: 'fixed',
      left: `${rect.left}px`,
      top: `${rect.bottom + 4}px`,
      width: `${rect.width}px`,
      zIndex: '9999',
      padding: '8px 10px',
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
      fontFamily: '"Archivo Medium", Archivo, sans-serif',
      fontSize: '14px',
      lineHeight: '1.4',
      color: '#444955',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      pointerEvents: 'none',
    });

    tooltip.textContent = value;
    document.body.appendChild(tooltip);
    this.tooltipEl = tooltip;
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.removeTooltip();
  }

  ngOnDestroy(): void {
    this.removeTooltip();
  }

  private removeTooltip(): void {
    this.tooltipEl?.remove();
    this.tooltipEl = null;
  }
}
